import { Media } from "../../../types/media";
import { CardFrame } from "../../../styles/styles";
import { DeleteMediaModal } from "../../Modals/DeleteMediaModal";

interface DeleteSectionProps {
  currentMedia: Media;
}

function DeleteSection({ currentMedia }: DeleteSectionProps) {
  return (
    <CardFrame>
      <DeleteMediaModal media={currentMedia} />
    </CardFrame>
  );
}

export { DeleteSection };
